export class Dashboard {
    email:string;
    activeStatus:boolean;
}
